// extracted by mini-css-extract-plugin
export default {"container":"footer_container__BjGJP","hr":"footer_hr__wivqt","content":"footer_content__Epy6s","ver":"footer_ver__NTU+Q","placeHolderShimmer":"footer_placeHolderShimmer__07dRm"};